import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import {
  FormGroup,
  FormControlLabel,
  Checkbox,Typography
} from "@mui/material";
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import axios from "../../../lib/axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import UnLock from "../../../GlobalFunction/UnLock";
import CrudButtons from '../../../GlobalFunction/CrudButtons';
// import { useModulePermissions } from '../../../GlobalFunction/useModulePermissions';
import ReportTable from '../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';

const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiFilledInput-root': {
    backgroundColor: 'transparent',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
  },
  '& .Mui-focused': {
    borderColor: '#673ab7',
  },
  '& .MuiFilledInput-root.Mui-focused': {
    border: '1px solid #673ab7',
  },
}));

const columns = [
  { id: 'RowNum', label: 'S.No.', minWidth: 170 },
  { id: 'SemesterName', label: 'Semester', minWidth: 100 },
  { id: 'Remark', label: 'Remark', minWidth: 100 }
];

const SemesterMaster = () => {
  const [formData, setFormData] = useState({
    SemesterName: '',
    Remark: ''
  });

  // const permissions = useModulePermissions("Semester Master");

  const [error, setError] = useState({
    semesterName: false
  });

  const navigate = useNavigate();

  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const location = useLocation();
  const [currentSemesterId, setCurrentSemesterId] = useState(null);
  const [courses, setCourses] = useState([]);
  const [mode, setMode] = useState('view');
  const [lastInsertedSemesterId, setLastInsertedSemesterId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [Status, setStatus] = useState("1");
  const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });
  
  const semesterNameRef = useRef(null);
  const remarkRef = useRef(null);

  useEffect(() => {
    if (location.state && location.state.SemesterId) {
      setCurrentSemesterId(location.state.SemesterId);
      fetchSemesterData(location.state.SemesterId);
      setMode('view');
    } else {
      setMode('add');
      setIsFormDisabled(false);
    }
  }, [location]);

  const fetchSemesterData = async (id, flag) => {
    try {
      const response = await axios.post(`MstSemester/RetriveMstSemester`, {
        SemesterId: parseInt(id),
        Flag: flag
      });

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const semesterData = response.data.Data[0];
        setFormData({
          SemesterName: semesterData.SemesterName,
          Remark: semesterData.Remark
        });
        setStatus(semesterData.Status.toString() || "0");
        setIsFormDisabled(true);
        setCurrentSemesterId(semesterData.SemesterId);
      } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
        toast.info(response.data.Message);
      } else {
        toast.error('Failed to fetch semester master data');
      }
    } catch (error) {
      console.error('Error fetching semester master data:', error);
      toast.error('Error fetching semester master data. Please try again.');
    }
  };

  useEffect(() => {
    const getRow = async () => {
      const params = {
        start: 1,
        PageSize: 1,
        SearchText: ""
      };
  
      try {
        const res = await axios.post('MstSemester/getAllMstSemesterDashBoard', { params });
  
        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          console.error('No data found in response');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };
  
    getRow();
  }, []);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(`MstCourse/getMstCoursedrp`);
        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
          setCourses(response.data.Data);
        } else {
          toast.error('Failed to fetch Courses');
        }
      } catch (error) {
        console.error('Error fetching Courses:', error);
        toast.error('Error fetching Courses. Please try again.');
      }
    };

    fetchCourses();
  }, []);

  const handlePrevious = async () => {
    if (currentSemesterId && currentSemesterId > 1) {
      await fetchSemesterData(currentSemesterId, "P");
    }
  };

  const handleNext = async () => {
    if (currentSemesterId) {
      await fetchSemesterData(currentSemesterId, "N");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    if (name === 'semester') {
      setFormData(prevState => ({
        ...prevState,
        state: ''
      }));
    }

    if (name === 'semester' && value !== '') {
      setTimeout(() => {
        remarkRef.current.focus();
      }, 100000);
    }
  };

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (event.target === semesterNameRef.current) {
        remarkRef.current.focus();
      } else {
        remarkRef.current.focus();
      }
    }
  }

  const handleSave = async () => {

    let hasError = false;

    if (!formData.SemesterName) {
      toast.error('Semester Name is required');
      setError(prev => ({ ...prev, semesterName: true }));
      hasError = true;
    } else {
      setError(prev => ({ ...prev, semesterName: false }));
    }

    if (hasError) {
      return;
    }


    try {
      const payload = {
        SemesterName: formData.SemesterName,
        Remark: formData.Remark,
        Status: Status
      };

      let response;
      if (mode === 'edit') {
        payload.SemesterId = currentSemesterId;
        payload.UpdatedBy = parseInt(UserId, 10);
        response = await axios.patch(`MstSemester/UpdateMstSemester`, payload);
      } else {
        payload.CreatedBy = parseInt(UserId, 10);
        response = await axios.post(`MstSemester/InsertMstSemester`, payload);
      }

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message);
        if (mode === 'add') {
          setLastInsertedSemesterId(response.data.Data)
          await fetchSemesterData(response.data.Data);
          setMode('view');
          setIsFormDisabled(true);
          setCurrentSemesterId(response.data.Data);
        } else {
          setMode('view');
        }
        setIsFormDisabled(true);
      } else {
        toast.error(response.data.Message || 'Operation failed');
      }
    } catch (error) {
      console.error('Error saving/updating Semester Master:', error);
      toast.error('Error saving/updating Semester Master. Please try again.');
    }
  };

  const handleEdit = async () => {

    let Flag = await checkAndLock(currentSemesterId, "MstSemester", "SemesterId");
    console.log(Flag);
    switch (Flag) {
      case 0:
        setMode("edit");
        setIsFormDisabled(false);
        break;
      case 1:
        toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleAdd = () => {
    setMode('add');
    setIsFormDisabled(false);
    setFormData({
      SemesterName: '',
      Remark: ''
    });
    setCurrentSemesterId(null);

    setTimeout(() => {
      semesterNameRef.current.focus();
    }, 0);
  };

  const handleCancel = async () => {
    try {
      await fetchSemesterData(1, "L");
      await UnLock(currentSemesterId, "MstSemester", "SemesterId");
      setMode('view');
      setIsFormDisabled(true);
    } catch (error) {
      toast.error('Error occurred while cancelling. Please try again.');
    }
  };

  const resetForm = () => {
    setFormData({
      SemesterName: '',
      Remark: ''
    });
    setCurrentSemesterId(null);
    setMode('view');
  };

  const handleExit = () => {
    navigate('/semestertable')
  }

  const handleDeleteClick = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {

    let Flag = await checkAndLock(currentSemesterId, "MstSemester", "SemesterId");
    switch (Flag) {
      case 0:
        setOpenConfirmDialog(false);
        await fetchSemesterData(currentSemesterId, "D");
        await fetchSemesterData(currentSemesterId, "N");
        setMode('view');
        setIsFormDisabled(true);
        break;
      case 1: toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default: toast.info("Something Went Wrong", { autoClose: 500 });

    }

  };

  return (
    <>

      <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>

        <ToastContainer />
        <Grid container spacing={2} className='form_grid'>
          <Grid item xs={12} className='form_title' 
            sx={{ display: 'flex', alignItems: 'center', 
                  justifyContent: 'space-between', marginTop: '20px',
                  flexDirection: { xs: 'column', sm: 'row', md: 'row' }  
                }}
              >
            <Grid
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-start' },
                marginBottom: { xs: '10px', sm: 0 }
              }}
            >
              <Button
                variant="contained"
                size="small"
                className='three-d-button-previous'
                onClick={handlePrevious}
                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                disabled={mode !== 'view' || !currentSemesterId || currentSemesterId === 1}
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                // sx={{ margin: '0px 10px' }}
                className='three-d-button-next'
                onClick={handleNext}
                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                disabled={mode !== 'view' || !currentSemesterId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            
            <Typography
              variant="h5"
              sx={{
                margin: 'Auto',
                textAlign: { xs: 'center', sm: 'center' },
                fontSize: { xs: '24px', sm: '18px', md: '24px' }
              }}
            >
              Semester Master
            </Typography>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Semester Master"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleConfirmDelete}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={isFormDisabled}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} className='form_field'>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={5}>
                <TextField
                  id="SemesterName"
                  name="SemesterName"
                  label={
                    <span>
                      Semester <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.SemesterName}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  error={error.semesterName}
                  helperText={error.semesterName && ""}
                  inputRef={semesterNameRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid item xs={12} md={5}>
                <TextField
                  fullWidth
                  label="Remark"
                  name="Remark"
                  value={formData.Remark}
                  onChange={handleInputChange}
                  variant="filled"
                  disabled={isFormDisabled}
                  className="custom-textfield"
                  inputRef={remarkRef}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={2}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isFormDisabled}
                        checked={Status === "1"}
                        onChange={handleChangeStatus}
                      />
                    }
                    label="Status"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button">
            {mode === 'view' && (
              <>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === 'edit' || mode === 'add') && (
              <>

                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave}>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}
                >
                  Cancel
                </Button>

              </>
            )}
          </Grid>
        </Grid>
      </Box>

      <div style={{ display: 'none' }}>
        {Object.keys(DataForPrint).length > 0 && <ReportTable
          columns={columns}
          rows={rows}
          title="Semester Master"
          contentRef={contentRef}
          customStyles={{ backgroundColor: '#f5f5f5' }}
        />
        }
      </div>

      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Deletion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default SemesterMaster